module.exports = __webpack_public_path__ + "img/flag_thai.76046533.png";